import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { showError } from "actions/notification";
import { linkedinLink, linkedinLogin, linkedinRegister } from "actions/oauth";
import PropTypes from "prop-types";

import Translate from "utils/translate";
import { getUrlParams } from "utils/urlParams";

const { t } = new Translate("LinkedinOauthCallback");

const LinkedinOAuthCallback = ({ history: { replace }, onError, onLink, onLogin, onRegister }) => {
  const { code, error, state } = getUrlParams();
  const handleError = () => {
    if (
      (error && error !== "user_cancelled_login" && error !== "user_cancelled_authorize") ||
      !error
    ) {
      onError(t("errorTitle"), t("errorBody"));
    }
    if (state && state === "register") return replace("/register");

    return replace("/login");
  };

  if (code && state && state === "link") {
    onLink(code)
      .then(() => replace("/settings/profile/integrations"))
      .catch(() => {
        onError();
        replace("/settings/profile/integrations");
      });
  } else if (code && state) {
    const action = state === "login" ? onLogin : onRegister;
    action(code)
      .then(({ value: { url } }) => {
        window.location = url;
      })
      .catch(handleError);
  } else {
    handleError();
  }

  return null;
};

LinkedinOAuthCallback.propTypes = {
  onError: PropTypes.func,
  onLogin: PropTypes.func,
  onLink: PropTypes.func,
  onRegister: PropTypes.func,
  history: PropTypes.shape({
    replace: PropTypes.func,
  }),
};

const mapDispatchToProps = (dispatch) => ({
  onError: (title, message) => dispatch(showError(title, message)),
  onLogin: (code) => dispatch(linkedinLogin(code)),
  onLink: (code) => dispatch(linkedinLink(code)),
  onRegister: (code) => dispatch(linkedinRegister(code)),
});

export default withRouter(connect(null, mapDispatchToProps)(LinkedinOAuthCallback));
